<template>
    <div
        class="text-sm text-cool-gray-600"
        v-html="content"
    ></div>
</template>

<script>
export default {
    name: 'text-block',

    components: {},

    props: {
        content: String,
    },

    data: function() {
        return {}
    },
}
</script>